declare namespace $ {

	type $mol_image__uri_bog_blitz_lobby_host_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $bog_qr__uri_bog_blitz_lobby_host_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_host['qr_data'] >
		,
		ReturnType< $bog_qr['uri'] >
	>
	type $bog_qr__error_correction_bog_blitz_lobby_host_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_qr['error_correction'] >
	>
	type $bog_qr__center_bog_blitz_lobby_host_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['center'] >
	>
	type $bog_qr__module_radius_bog_blitz_lobby_host_5 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_qr['module_radius'] >
	>
	type $bog_qr__finder_radius_bog_blitz_lobby_host_6 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_qr['finder_radius'] >
	>
	type $bog_qr__gradient_angle_bog_blitz_lobby_host_7 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_qr['gradient_angle'] >
	>
	type $bog_qr__gradient_stops_bog_blitz_lobby_host_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_qr['gradient_stops'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_host_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_host['quiz_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_host_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_host['land_id'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_bog_blitz_lobby_host_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_lobby_host_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_host['start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_host_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_host['counter_string'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_blitz_lobby_host extends $mol_page {
		qr_data( ): string
		Logo( ): $mol_image
		Qr( ): $bog_qr
		Quiz_title( ): $mol_paragraph
		Land_id( ): $mol_paragraph
		start( next?: any ): any
		Start( ): $mol_button_major
		Counter( ): $mol_paragraph
		Players( ): $bog_blitz_lobby_players
		Head( ): any
		counter_string( ): string
		land_id( ): string
		quiz_title( ): string
		session( ): any
		quiz_data( ): any
		body( ): readonly(any)[]
		Foot( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=host.view.tree.d.ts.map